
let app

export default {
    setApp: (appp) => {
        app = appp
    },
    "title": "Countries Data",
    "entityName": "countries_data",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [

        {
            full:true,
            "value": "country_id",
            "text": "Country",
            "title" : "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            
        },


        {
            full:true,
            "value": "info",
            "text": "Info",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['info'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.info ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'info')
            }
        },

        {
            full:true,
            "value": "geo",
            "text": "Geo",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['geo'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.geo ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'geo')
            }
        },


        {
            full:true,
            "value": "history",
            "text": "History",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['history'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.history ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'history')
            }
        },


        {
            full:true,
            "value": "culture",
            "text": "Culture",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['culture'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.culture ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'culture')
            }
        },


        {
            full:true,
            "value": "weather",
            "text": "Weather",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['weather'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.weather ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'weather')
            }
        },

        {
            full:true,
            "value": "travels",
            "text": "Travels",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['travels'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.travels ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'travels')
            }
        },


        {
            full:true,
            "value": "docs",
            "text": "Docs",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['docs'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.docs ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'docs')
            }
        },

        {
            full:true,
            "value": "notes",
            "text": "Notes",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['notes'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.notes ?  "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'notes')
            }
        },

        {
            full:true,
            "value": "poi",
            "text": "Poi",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['poi'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.poi ? "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'poi')
            }
        },

        {
            full:true,
            "value": "covid19",
            "text": "Covid19",
            "type": "list",
            "list": ['true', 'false'],
            "table": {
                "sortable": false,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (search) => {
                return search['covid19'] == 'true' ? '!=NULL'  : 'NULL'
            },
            render: (item) => {
                return item.covid19 ? "<span><i  class='v-icon mdi mdi-check theme--light green--text'></i></span>" : "<span color='red'><i class='v-icon mdi mdi-close theme--light red--text'></i></span>"
            },
            click: (item) => {
                app.upsert(item,'covid19')
            }
        },


    ],
    "actions": [
    ]
}